import React from 'react';

import {Link} from 'react-router';

import {GenericPaginatedListRTK} from 'app/components/general/lists/GenericPaginatedListRTK';
import NoResultsMessage from 'app/components/general/NoResultsMessage';
import {useCurrentUserState} from 'app/current-user/api';
import {getCurrentUserPerms} from 'app/current-user/utils';
import {useFolders} from 'app/folders/api';
import {CreateFolderButton} from 'app/folders/components/dashboards/CreateFolder';
import {CreateFolderLink} from 'app/folders/components/dashboards/CreateFolderLink';
import {StyledListRowDIV} from 'app/general/bootstrap/utils';
import {sweetAPI} from 'app/store/sweet-api';
import {HOME_TODOS_DASHBOARD} from 'app/urls';
import {DEFAULT_PAGE_SIZE} from 'app/utils/constants';
import {gt} from 'app/utils/i18n';
import {useAsyncActions} from 'app/utils/redux';
import {FOLDER_TAGS} from 'app/utils/rtk-tags';

import {useCurrentFolder} from './FolderContext';
import {FolderWidget} from './FolderWidget';

import {FolderSerializedType} from 'sweet-types';

export function HomeFoldersDashboard() {
  return (
    <>
      <h4 className="border-bottom pb-2 mt-4 text-muted text-uppercase">
        {gt('More Dashboards')}
      </h4>
      <Link to={HOME_TODOS_DASHBOARD}>{gt('My Action Center')}</Link>
      <FoldersList parent="" />;
    </>
  );
}

interface FoldersListProps {
  parent: string;
}
export function FoldersList({parent}: FoldersListProps) {
  const actions = useAsyncActions({
    invalidateTags: sweetAPI.util.invalidateTags,
  });

  const {folder: currentFolder} = useCurrentFolder();
  const {isManager} = getCurrentUserPerms(useCurrentUserState().data!);

  function refetchFolders() {
    // @ts-expect-error we inject tags on the API after it's created so TS doesn't know any tag type
    actions.invalidateTags([{type: FOLDER_TAGS.TAG, id: 'list'}]);
    return Promise.resolve(true);
  }

  return (
    <div className="py-4">
      <h4
        id="folders"
        className="d-flex justify-content-between align-items-center border-bottom pb-2 my-4 text-muted text-uppercase"
      >
        {gt('Folders')}
        <CreateFolderLink
          className="btn btn-link btn-sm d-flex text-muted"
          autoFocus={true}
          parent={currentFolder ?? null}
          teams={currentFolder?.teams}
          canEdit={currentFolder?.can_edit ?? isManager}
        />
      </h4>
      <GenericPaginatedListRTK
        WrapperComponent={StyledListRowDIV}
        ItemComponent={FolderWidget}
        useQuery={useFolders}
        noItemsMessage={() => (
          <NoResultsMessage head={gt('No folders found.')} onSidebar={true}>
            <div className="d-flex justify-content-center">
              <CreateFolderButton
                canEdit={currentFolder?.can_edit || isManager}
                allowedTeams={currentFolder?.teams || []}
                parent={currentFolder as FolderSerializedType}
                className="btn btn-primary btn-sm pr-2"
              />
            </div>
          </NoResultsMessage>
        )}
        pageParamName="folders_page"
        paramsBuilder={() => ({
          parent,
          page_size: DEFAULT_PAGE_SIZE,
        })}
        customProps={() => {
          return {
            refetchFolders,
          };
        }}
      />
    </div>
  );
}
